import React from "react";
import { t } from "../../../i18n";

/**
 * Renders the backend-driven filter pills. The active pill is derived from the
 * Redux-persisted filter type so it survives navigation. A leading "All" pill
 * clears the type filter and is highlighted whenever no specific type is set.
 */
const WalletPills = (props) => {
  const { pills, activeType, onPillChange } = props;
  if (!pills || pills.length === 0) return null;

  const pillValue = (pill) =>
    pill.value !== undefined ? pill.value : (pill.type !== undefined ? pill.type : pill.id);

  // "All" is active when no specific type is selected.
  const allActive = activeType === undefined || activeType === null || activeType === "";

  return (
    <div className="wallet-pills">
      <button
        type="button"
        className={
          allActive
            ? "wallet-pills-item wallet-pills-item-active"
            : "wallet-pills-item"
        }
        onClick={() => onPillChange("")}
      >
        {t("gamification2026.wallet.filters.all")}
      </button>
      {pills.map((pill) => {
        const value = pillValue(pill);
        const isActive = activeType === value;
        const className = isActive
          ? "wallet-pills-item wallet-pills-item-active"
          : "wallet-pills-item";

        return (
          <button
            key={pill.id !== undefined ? pill.id : value}
            type="button"
            className={className}
            onClick={() => onPillChange(isActive ? "" : value)}
          >
            {pill.label || pill.name}
          </button>
        );
      })}
    </div>
  );
};

export default WalletPills;
